<template>
  <main :class="size || ''">
    <div class="content-wrapper">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'AppContent',
  components: { },
  props: {
    size: String
  }
}
</script>

<style lang="scss" scoped>
main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;

  .content-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 0 2rem;

    .content {
      width: 100%;
      max-width: 42rem;
      background: var(--color-page);
      padding: 2rem;
      border-radius: 2rem;
      margin-top: 5rem;
    }
  }

  &.wide {
    .content {
      max-width: 80rem;
    }
  }
  &.full {
    .content {
      max-width: unset;
    }
  }
}

@media only screen and (max-width: 600px) {
  main .content-wrapper {
    padding: 0 0;
  }
  main .content-wrapper .content {
    padding: var(--side-padding);
    margin-top: 0;
    border-radius: 0;
  }
}
</style>